import { ComponentProps } from "react";
import GaraazSearch from "./GaraazSearch";
import CustomerSearchResultItem from "./CustomerSearchResultItem";
import endpoints from "../utils/endpoints";

type GaraazSearchProps = ComponentProps<typeof GaraazSearch>;

type Props = Omit<
  GaraazSearchProps,
  "queryUrl" | "idField" | "valueField" | "renderItem" | "acceptMobileNumber"
>;

/**
 * Customer typeahead with the shared rich dropdown row
 * (avatar + name / owner | mobile / association). Use this for every
 * customer search in OrCA so the display stays consistent.
 */
const CustomerSearch = (props: Props) => {
  return (
    <GaraazSearch
      {...props}
      queryUrl={endpoints.searchXpressCustomer}
      idField="_id"
      valueField="name"
      acceptMobileNumber
      renderItem={(customer) => (
        <CustomerSearchResultItem customer={customer} />
      )}
    />
  );
};

export default CustomerSearch;
